import { render, staticRenderFns } from "./DurationQuickSettings.vue?vue&type=template&id=759366a2&"
import script from "./DurationQuickSettings.vue?vue&type=script&lang=js&"
export * from "./DurationQuickSettings.vue?vue&type=script&lang=js&"
import style0 from "./DurationQuickSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports